import { MoodConfig } from "../types/mood-config-types";

export const ExcitedMoodConfig: MoodConfig = {
  id: "EXCITED",
  backgroundGradientId: "paint0_linear_51_4614",
  targetColors: ["#FF8CD1", "#FFE05B"],
  elements: [
    {
      id: "Sun",
      type: "ellipse",
      cx: 390.647,
      cy: 52.1059,
      rx: 31.0197,
      ry: 31.3647,
      fill: "url(#paint4_linear_51_4614)",
      initial: { y: 430, duration: 3 },
      animate: { y: 0, scale: [1, 1.6, 1] },
      exit: { y: 430, transition: { duration: 4.2 } },
      transition: {
        duration: 5,
        scale: {
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut",
        },
        ease: "easeOut",
      },
    },
    {
      id: "Shape 2",
      type: "path",
      d: "M-41.864 319.651C-41.864 319.651 20.8848 280.259 68.28 280.259C130.973 280.259 172.889 333.982 223.602 333.982C282.705 333.982 290.143 318.458 323.285 318.458C370.128 318.458 431.952 347.568 464.557 337.062C490.868 328.584 522.544 311.459 522.544 311.459V455.252L-41.864 463.894V319.651Z",
      fill: "url(#paint2_linear_51_4614)",
      initial: { y: 250 },
      animate: { y: 0, x: [0, 40, 0] },
      exit: { y: 200, transition: { duration: 2.4, delay: 2.8 } },
      transition: {
        duration: 4,
        x: {
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut",
        },
        ease: "easeOut",
      },
    },
    {
      id: "Shape 1",
      type: "path",
      d: "M535.089 443.849C535.089 443.849 532.114 349.862 464.682 335.166C405.724 326.426 360.269 394.26 307.549 394.26C246.107 394.26 217.151 354.892 157.496 354.892C113.987 354.892 71.5016 389.119 12.2527 377.255C-119.349 350.903 -51.6566 346.382 -51.6566 346.382V495.774L535.089 504.753V443.849Z",
      fill: "url(#paint3_linear_51_4614)",
      initial: { y: 250 },
      animate: { y: 0, x: [0, -40, 0] },
      exit: { y: 200, transition: { duration: 2.4, delay: 2.8 } },
      transition: {
        duration: 4,
        x: {
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut",
        },
        ease: "easeOut",
      },
    },
    {
      id: "Cloud 1",
      type: "path",
      d: "M427.726 109.27H381.097C366.732 109.27 355.088 97.5725 355.088 83.1423C355.088 68.7122 366.732 57.0142 381.097 57.0142C385.432 57.0142 389.519 58.0795 393.113 59.9636C398.118 45.3814 411.898 34.9058 428.114 34.9058C448.556 34.9058 465.128 51.5529 465.128 72.0881C465.128 72.509 465.121 72.9282 465.107 73.3457C471.074 76.5662 475.132 82.8956 475.132 90.1768C475.132 100.722 466.622 109.27 456.125 109.27H428.114C428.056 109.27 427.726 109.27 427.726 109.27H428.114H427.726Z",
      fill: "url(#paint5_linear_51_4614)",
      initial: { x: 500 },
      animate: { x: 0, y: [0, 25, 0] },
      exit: { x: 140, transition: { duration: 3 } },
      transition: {
        duration: 5,
        y: {
          duration: 4,
          repeat: Infinity,
        },
      },
    },
    {
      id: "Cloud 2",
      type: "path",
      d: "M22.514 232.706H59.5428C70.95 232.706 80.1974 223.395 80.1974 211.91C80.1974 200.425 70.95 191.114 59.5428 191.114C56.1004 191.114 52.8548 191.962 50.0006 193.462C46.0263 181.855 35.083 173.518 22.2056 173.518C5.97226 173.518 -7.18748 186.767 -7.18748 203.112C-7.18748 203.447 -7.18195 203.78 -7.17097 204.113C-11.9097 206.676 -15.1316 211.714 -15.1316 217.509C-15.1316 225.902 -8.37386 232.706 -0.0378036 232.706H22.2056C22.252 232.706 22.514 232.706 22.514 232.706H22.2056H22.514Z",
      fill: "url(#paint1_linear_51_4614)",
      initial: { x: -150 },
      animate: { x: 0, y: [0, 25, 0] },
      exit: { x: -150, transition: { duration: 3 } },
      transition: {
        duration: 5,
        y: {
          duration: 4,
          repeat: Infinity,
        },
      },
    },
  ],
  linearGradients: [
    {
      id: "paint0_linear_51_4614",
      x1: -124.204,
      y1: 0,
      x2: -124.204,
      y2: 1081.52,
      stops: [
        { offset: 0.0677083, stopColor: "#FF8CD1" },
        { offset: 0.828125, stopColor: "#FFE05B" },
      ],
    },
    {
      id: "paint1_linear_51_4614",
      x1: 80.1974,
      y1: 173.518,
      x2: 80.1974,
      y2: 232.706,
      stops: [{ stopColor: "white" }, { offset: 1, stopColor: "white" }],
    },
    {
      id: "paint2_linear_51_4614",
      x1: -41.864,
      y1: 280.259,
      x2: -41.864,
      y2: 463.894,
      stops: [{ stopColor: "#FFB022" }, { offset: 1, stopColor: "#FFD6BE" }],
    },
    {
      id: "paint3_linear_51_4614",
      x1: 73.1361,
      y1: 148.582,
      x2: 73.1361,
      y2: 213.112,
      stops: [
        { stopColor: "#FED54C" },
        { offset: 1, stopColor: "#FEDD3A", stopOpacity: 1 },
      ],
    },
    {
      id: "paint4_linear_51_4614",
      x1: 359.627,
      y1: 44.4658,
      x2: 359.627,
      y2: 156.715,
      stops: [{ stopColor: "#FED54C" }, { offset: 1, stopColor: "#FEDD3A" }],
    },
    {
      id: "paint5_linear_51_4614",
      x1: 355.088,
      y1: 34.9058,
      x2: 355.088,
      y2: 109.27,
      stops: [{ stopColor: "white" }, { offset: 1, stopColor: "white" }],
    },
  ],
};
